var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-view",class:{
    'c-view--white': _vm.hasWhiteBackground,
    'c-view--no-scroll': _vm.noScroll,
    'c-view--bottom-padding': _vm.bottomPadding,
    'c-view--extra-bottom-padding': _vm.extraBottomPadding,
    'c-view--flex': _vm.flex
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }